import { render, staticRenderFns } from "./AssignTableLamps.vue?vue&type=template&id=b2b60d90&scoped=true&"
import script from "./AssignTableLamps.vue?vue&type=script&lang=ts&"
export * from "./AssignTableLamps.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableLamps.vue?vue&type=style&index=0&id=b2b60d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b60d90",
  null
  
)

export default component.exports